import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PreguntaRow=({pregunta, onShowModalBorrar, onShowModalActivar, color,form, permisos, editar={editar}})=>{
    return (
    <Table.Row>
                        <Table.Cell>{pregunta.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{pregunta.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
    
                                       <Popup
                                            trigger={<Icon onClick={()=>editar(pregunta.id)}  name='edit outline' link   size="large"  color="teal" ></Icon>}
                                            content='Editar'   
                                          />

                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(pregunta.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={pregunta.idEstatus==1?'x':'check'} link  size="large" 
                                                color={pregunta.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(pregunta.id)} 
                                            />
                                        }
                                        content={pregunta.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default PreguntaRow;